import styled from "styled-components";
import { gridConfig } from "@tvg/fuse-responsive-grid";
import { TypographyComponent } from "@tvg/fuse-typography-element";

export const HeaderContainer = styled.div`
  padding-top: var(--spacing-space16);

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    padding-top: 31px; // TODO: change to var(--spacing-space32) after changing in Header fragment in another repo;
  }
`;

export const StyledSearchLabelRowNonDesktop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: var(--spacing-space24);
  padding-left: var(--spacing-space16);
  padding-bottom: var(--spacing-space8);

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    padding-right: var(--spacing-space32);
    padding-left: var(--spacing-space24);
  }

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: none;
  }
`;

export const SearchLabel = styled(TypographyComponent)`
  flex: 1 0 0;
`;

export const SearchContainer = styled.div`
  padding: 0 var(--spacing-space16);
  box-sizing: border-box;

  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: var(--spacing-space8);

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    padding: 0 var(--spacing-space24);
  }

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    margin-bottom: var(--spacing-space32);
  }
`;

export const MockLogo = styled.div`
  display: none;
  width: var(--spacing-em64);

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: block;
  }
`;

export const CloseIconContainer = styled.div<{ $originalWidth: string }>`
  display: none;
  width: ${(props) => `${props.$originalWidth}px`};
  margin-left: var(--spacing-space24);
  padding-right: var(--spacing-space24);
  justify-content: flex-end;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: flex;
  }
`;
